import React from 'react'
import propTypes from 'prop-types'

import { connectApi } from 'libs/connectApi'
import constants from 'config/constants'
import { CSATWidget } from './index'
import { Loader } from 'shared/components/Loader'

class CSATWidgetContainer extends React.Component {
  static propTypes = {
    companyKey: propTypes.string.isRequired,
    companySurvey: propTypes.object,
  }

  getFirstCSATToken = () => {
    const CSATSurvey = this.props.companySurvey.data.results.filter(
      (result) => !constants.emailSurveyTypes.includes(result.survey.type)
    )
    if (CSATSurvey.length !== 0) {
      const firstCSATToken = CSATSurvey[CSATSurvey.length - 1].survey.token
      return firstCSATToken
    }
    return ''
  }

  componentDidMount() {
    if (!this.props.companySurvey.data) {
      this.props.companySurvey.callApi()
    }
  }

  render() {
    return !this.props.companySurvey.data ? (
      <div style={{ position: 'relative', minHeight: 310 }}>
        <Loader />
      </div>
    ) : (
      <CSATWidget genericToken={this.getFirstCSATToken()} companyKey={this.props.companyKey} />
    )
  }
}

export default connectApi({
  name: 'companySurvey',
  url: 'account/survey/?limit=5000&order_by=asc',
  schema: { results: [{ survey: '@Survey' }] },
  skip: true,
})(CSATWidgetContainer)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/CSATWidget/container.js